import { Instance, SnapshotIn, types } from 'mobx-state-tree'

import { parseBackendUtcDateString } from 'utils/datetimeUtils'
import { ChecklistKind, CHECKLIST_KIND_DISPLAY_NAMES } from '../Checklists/ChecklistKind'
import { ErrorModel } from '../common/OperationStatus'
import { PagingMetadataModel } from '../common/PagingMetadataModel'

const ChecklistReportModel = types
  .model('ChecklistReportModel')
  .props({
    audit_log_id: types.number,

    user_name: types.string,
    timestamp: types.string,

    mission_id: types.maybeNull(types.string),
    checklist_name: types.maybeNull(types.string),
    checklist_type: types.maybeNull(types.string),
    center_name: types.maybe(types.string),
    vehicle_name: types.maybeNull(types.string),

    report_file_path: types.maybeNull(types.string),

    fetchError: types.maybeNull(ErrorModel),
  })
  .views((self) => ({
    get userName(): typeof self.user_name {
      return self.user_name
    },
    get missionId(): typeof self.mission_id {
      return self.mission_id
    },
    get checklistDisplayName(): typeof self.checklist_name {
      return self.checklist_name ?? '--'
    },
    get centerName(): typeof self.center_name {
      return self.center_name
    },
    get vehicleName(): typeof self.vehicle_name {
      return self.vehicle_name
    },
    get timestampDate(): Date {
      return parseBackendUtcDateString(self.timestamp)
    }
  }))
  .views((self) => ({
    get checklistTypeDisplayName(): string {
      if (self.checklist_type === null) return '--'

      const checklistKind = self.checklist_type as ChecklistKind
      return CHECKLIST_KIND_DISPLAY_NAMES[checklistKind] ?? self.checklist_type
    },
  }))

// ChecklistReportsReportModel - A report where each row is a checklist reports.
// (The name is a bit confusing here)
export const ChecklistReportsReportModel = types.model('ChecklistReportsReportModel', {
  metadata: PagingMetadataModel,
  checklist_reports: types.array(ChecklistReportModel),
})

export type ChecklistReport = Instance<typeof ChecklistReportModel>
export type ChecklistReportSnapshot = SnapshotIn<typeof ChecklistReportModel>
export type ChecklistReportsReport = Instance<typeof ChecklistReportsReportModel>
export type ChecklistReportsReportSnapshot = SnapshotIn<typeof ChecklistReportsReportModel>
